import { render, staticRenderFns } from "./AddNewCrmProjectNotes.vue?vue&type=template&id=288e8fea"
import script from "./AddNewCrmProjectNotes.vue?vue&type=script&lang=js"
export * from "./AddNewCrmProjectNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports